//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = (fox) => {
	//@ts-ignore
	const RuleBase = require('../rule')(fox);
	//@ts-ignore
	const patchTipsForm = require('./common/patch-tips-form');
	//@ts-ignore
	const patchStoreContent = require('./common/patch-store-buy');
	//@ts-ignore
	const patchJoinForm = require('./common/patch-join-form');
	//@ts-ignore
	const patchGiftbox = require('./common/patch-giftbox');
	//@ts-ignore
	const patchLiveshowTranslator = require('./common/patch-liveshow-translator');
	//@ts-ignore
	const patchNewsletterSubscribe = require('./common/patch-newsletter-subscribe');

	return fox.extend({
		__constructor(pm, fakeParams, ...args) {
			const params = {};

			Object.defineProperty(params, 'enabled', {
				get: () => pm.hasAccess('guest') && fox.isEmpty(pm.member),
				enumerable: true
			});

			pm.handleEvent(
				pm,
				'permissions_update',
				/** @param {Array} keys */
				(keys) => {
					if (keys.indexOf('guest') !== -1) {
						this.execute();
					}
				},
				{
					prefix: 'guest_actual_rule_handler',
					sync: true
				}
			);

			this.super('__constructor', [pm, params, ...args]);
		},

		prepareParams(values) {
			if (fox.isBoolean(values)) {
				return {
					result: values,
					params: null
				};
			}

			return {
				result: true,
				params: Object.keys(values).reduce((obj, key) => {
					obj[`transitParams[${key}]`] = values[key];

					return obj;
				}, {})
			};
		},

		granted() {
			const gdprPopup = this.pm.rwom1('@root #gdprMainPopup');

			patchTipsForm(this, () => gdprPopup.show().then(this.prepareParams));
			patchStoreContent(this, (widget, resolver) => {
				return widget.guestForm.submit().then((values) => {
					if (values !== false) {
						return gdprPopup.show().then(this.prepareParams).then((result) => {
							if (result.result === true) {
								resolver(result.result);
							}

							return result;
						});
					}
				});
			}, fox.Promise);
			patchJoinForm(this, () => gdprPopup.show().then(this.prepareParams));
			patchGiftbox(this, () => gdprPopup.show().then(this.prepareParams));
			patchLiveshowTranslator(this, () => gdprPopup.show().then(this.prepareParams));
		},

		denied() {
			patchTipsForm(this, () => fox.Promise.resolve(this.prepareParams({})));
			patchStoreContent(this, (widget, resolver) => {
				resolver(true);
				return fox.Promise.resolve(this.prepareParams({}));
			});
			patchJoinForm(this, () => fox.Promise.resolve(this.prepareParams({})));
			patchGiftbox(this, () => fox.Promise.resolve(this.prepareParams({})));
			patchLiveshowTranslator(this, () => fox.Promise.resolve(this.prepareParams({})));
		}
	}, RuleBase, null, 'Rule_GuestActual')
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/guestActual.es.js